import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const updateRealPaymentAmount = createAction(Constants.UPDATE_REAL_PAYMENT_AMOUNT_ORDER.REQUEST, (datas) => (datas));
export const updateRealRefundAmount = createAction(Constants.UPDATE_REAL_REFUND_AMOUNT_ORDER.REQUEST, (datas) => (datas));

export const clearErrorRealPayment = createAction(Constants.CLEAR_ERROR_UPDATE_REAL_PAYMENT_AMOUNT_ORDER, () => ({}));
export const clearErrorRealRefund = createAction(Constants.CLEAR_ERROR_UPDATE_REAL_REFUND_AMOUNT_ORDER, () => ({}));
